import {useState, useEffect, useCallback} from "react";
import {CustomMark} from "../types";
import {CUSTOM_MARKS_STORAGE_KEY} from "../constants";

export function useCustomMarks() {
    const loadCustomMarksFromStorage = (): CustomMark[] => {
        try {
            const stored = localStorage.getItem(CUSTOM_MARKS_STORAGE_KEY);
            if (stored) {
                const marks = JSON.parse(stored);
                // Обратная совместимость: если у метки нет color, устанавливаем green по умолчанию
                return marks.map((mark: any) => ({
                    ...mark,
                    color: mark.color || "green",
                }));
            }
        } catch (error) {
            console.error("Ошибка при загрузке меток из LocalStorage:", error);
        }
        return [];
    };

    const [customMarks, setCustomMarks] = useState<CustomMark[]>(
        loadCustomMarksFromStorage
    );

    useEffect(() => {
        try {
            localStorage.setItem(
                CUSTOM_MARKS_STORAGE_KEY,
                JSON.stringify(customMarks)
            );
        } catch (error) {
            console.error("Ошибка при сохранении меток в LocalStorage:", error);
        }
    }, [customMarks]);

    const addMark = useCallback((mark: CustomMark) => {
        setCustomMarks((prev) => [...prev, mark]);
    }, []);

    return {customMarks, addMark};
}